export default __webpack_public_path__ + "content/media/16.299f4f19.jpg";